import { del, get, post, put } from "./apiUtilities";
import apiPaths from "./apiPaths";
import { ShipmentUpdateModel } from "../apiModels/shipmentUpdateModel";
import { ShipmentStatusModel } from "../apiModels/shipmentStatusModel";
import { ShipmentUpdateCreateModel } from "../apiModels/shipmentUpdateCreateModel";
import { ShipmentUpdateEditModel } from "../apiModels/shipmentUpdateEditModel";

export const getShipmentUpdates = async (trackingNumber: string) => await get<ShipmentUpdateModel[]>(`${apiPaths.getShipmentUpdates}/${trackingNumber}`);

export const getStatusOptions = async () => await get<ShipmentStatusModel[]>(apiPaths.getStatusOptions);

export const createShipmentUpdate = async (shipmentUpdate: ShipmentUpdateCreateModel) => await post(apiPaths.createShipmentUpdate, {
    body: JSON.stringify(shipmentUpdate)
});

export const editShipmentUpdate = async (shipmentUpdate: ShipmentUpdateEditModel) => await put(apiPaths.editShipmentUpdate, {
    body: JSON.stringify(shipmentUpdate)
});

export const deleteShipmentUpdate = async (shipmentUpdateId: number) => await del(`${apiPaths.deleteShipmentUpdate}/${shipmentUpdateId}`);